;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Menu from "../Menu"
import MenuItem from "../MenuItem"
import Divider from "../Divider"
import CompactOrgSwitcher from "../CompactOrgSwitcher"
import {
  TOP_NAV_MENU_TYPE_ACCOUNT,
  TOP_NAV_MENU_TYPE_BECOME_GROUP_LEADER,
  TOP_NAV_MENU_TYPE_FIND_A_GROUP,
  TOP_NAV_MENU_TYPE_LOGOUT,
  TOP_NAV_MENU_TYPE_NEWSLETTER_ACCOUNT_SETTING,
  TOP_NAV_MENU_TYPE_MESSAGES,
  TOP_NAV_MENU_TYPE_NOTIFICATIONS,
  TOP_NAV_MENU_TYPE_ARTICLE_STUDIO,
} from "../constants"

export default function MenuMemberOnly({
  trigger,
  handleLogout,
  unreadMsgCount,
  notificationCount,
  userId,
  orgId,
}: {
  trigger: React.ReactElement
  handleLogout: () => void | Promise<void>
  unreadMsgCount: number
  notificationCount: number
  userId?: number | null
  orgId?: string | number | null
}) {
  return (
    <Menu trigger={trigger}>
      {/* Messages and Notifications at top */}
      <MenuItem
        topNavMenuItemType={TOP_NAV_MENU_TYPE_MESSAGES}
        badgeCount={unreadMsgCount}
      />
      <MenuItem
        topNavMenuItemType={TOP_NAV_MENU_TYPE_NOTIFICATIONS}
        badgeCount={notificationCount}
      />
      <Divider />
      {/* Compact Org Switcher */}
      <CompactOrgSwitcher userId={userId} orgId={orgId} />
      <Divider />
      {/* Menu Items */}
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_FIND_A_GROUP} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_BECOME_GROUP_LEADER} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_NEWSLETTER_ACCOUNT_SETTING} />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ARTICLE_STUDIO} />
      <Divider />
      <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ACCOUNT} />
      <MenuItem
        topNavMenuItemType={TOP_NAV_MENU_TYPE_LOGOUT}
        handleLogout={handleLogout}
      />
    </Menu>
  )
}
